import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import * as React from "react";
import { Button, Chip, Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { CustomTable } from "../../../shared";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { sortItems } from "../../../utils";
import { usePointPromotionList } from "../hooks";
import InputControl from "../../../shared/components/InputControl";

const pointPromotionTypes = [
  { label: "Sales Multiplier", value: "sales_multiplier" },
  { label: "Sales Bonus", value: "sales_bonus" },
];

const pointPromotionStatusOptions = [
  { label: "Published", value: "published" },
  { label: "Draft", value: "draft" },
  { label: "Paused", value: "unpublished" },
  { label: "Ended", value: "ended" },
];

export const PointPromotionList = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const { state, globalData, handleStatusFilter, resetFilter } =
    usePointPromotionList({
    isList: true,
  });
  const { isLoading, dataList, filter } = state;

  const breadcrumbLinks = [
    { name: "Dashboard", href: isStoreAdmin ? "/store-admin" : "/" },
    { name: "Point Promotions" },
  ];

  const ActionButtons = ({ id }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <Link to={`/point-promotions/details/${id}`}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Promotion Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value }) => {
          return pointPromotionTypes.find((v) => v.value == value)?.label;
        },
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Card Type",
        accessor: "card_type",
        Cell: ({ value }) => {
          return value
            ? globalData?.points_promotions?.card_type?.find(
                (v) => v.value == value,
              )?.label
            : "--";
        },
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Incentive",
        accessor: "incentive",
        Cell: ({ value }) => {
          return <span style={{ fontWeight: "500" }}>{value}</span>;
        },
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "End Date",
        accessor: "end_date",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Status",
        accessor: "status",
        disableGlobalFilter: true,
        Cell: ({ value }) => {
          return (
            <>
              {value === "published" && (
                <Chip
                  label="Published"
                  color="success"
                  variant="outlined"
                  size="small"
                  sx={{ bgcolor: "#E8F5E914", border: "none !important" }}
                  disabled={false}
                />
              )}
              {value === "draft" && (
                <Chip
                  label="Draft"
                  color="primary"
                  variant="outlined"
                  size="small"
                  sx={{ bgcolor: "#1560D414", border: "none !important" }}
                  disabled={false}
                />
              )}
              {value === "unpublished" && (
                <Chip
                  label="Paused"
                  color="warning"
                  variant="outlined"
                  size="small"
                  sx={{ bgcolor: "#FFF4CE", border: "none !important" }}
                  disabled={false}
                />
              )}
              {value === "ended" && (
                <Chip
                  label="Ended"
                  color="success"
                  variant="outlined"
                  size="small"
                  disabled
                />
              )}
            </>
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        accessor: "id",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        Cell: ({ value }) => {
          return (
            <ActionButtons
              id={value}
              // deleteAction={() => handleModal(true, value)}
            />
          );
        },
      },
    ],
    [globalData],
  );

  return (
    <>
      <ContentLayout
        title="Point Promotions"
        breadcrumbs={<HeaderBreadcrumbs links={breadcrumbLinks} />}
        rightContent={
          <>
            <Button
              type="button"
              size="medium"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/point-promotions/create")}
            >
              Add Promotion
            </Button>
          </>
        }
      >
        <CustomTable
          columns={columns}
          data={dataList}
          isLoading={isLoading}
          tableId="point-promotions"
          filterContent={
            <>
              <InputControl
                type="select"
                name="status"
                label="Status"
                optionValue={pointPromotionStatusOptions}
                width="150px"
                onChange={handleStatusFilter}
                value={filter?.status || ""}
              />
              <Button
                type="button"
                size="medium"
                variant="text"
                color="gray"
                sx={{
                  minWidth: "40px",
                  p: "8px",
                }}
                onClick={resetFilter}
              >
                <img alt="close" src="/icons/ic_close.svg" />
              </Button>
            </>
          }
          onRowLink={(e) => {
            return `/point-promotions/details/${e.id}`;
          }}
        />
      </ContentLayout>
    </>
  );
};
